import * as React from 'react';
import { useDayPicker } from '../../contexts';
/**
 * Render the content of the day cell.
 */
export function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, labelDay = _a.labels.labelDay, formatDay = _a.formatters.formatDay;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { "aria-hidden": "true" }, formatDay(props.date, { locale: locale })),
        React.createElement("span", { className: classNames.vhidden, style: styles.vhidden }, labelDay(props.date, props.modifiers, { locale: locale }))));
}
//# sourceMappingURL=DayContent.js.map